import { DtoInclude, DtoRef } from '../../../core/store/dto/dto';
import { RestrictedAccountObjectDto } from '../restricted-account-object/restricted-account-object.dto';

export class ContactDto extends RestrictedAccountObjectDto {

    @DtoInclude
    business: string;
    @DtoInclude
    name: string;
    @DtoInclude
    email: string;
    @DtoInclude
    mobile: string;
    @DtoInclude
    phone: string;
    @DtoInclude
    fax: string;
    @DtoInclude
    website: string;
    @DtoInclude
    address: string;
    @DtoInclude
    address2: string;
    @DtoInclude
    address3: string;
    @DtoInclude
    billingCode: string;
    @DtoRef
    contactType: string;
    @DtoInclude
    vatNumber: string;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact/contact.dto.ts